__turbopack_context__.v({
  "aside": "PageFrame-module__Yyy_ma__aside",
  "currentlyWorkingOn": "PageFrame-module__Yyy_ma__currentlyWorkingOn",
  "logo": "PageFrame-module__Yyy_ma__logo",
  "logo-animation": "PageFrame-module__Yyy_ma__logo-animation",
  "menu": "PageFrame-module__Yyy_ma__menu",
  "menuItem": "PageFrame-module__Yyy_ma__menuItem",
  "menuItemBackground": "PageFrame-module__Yyy_ma__menuItemBackground",
  "pageContent": "PageFrame-module__Yyy_ma__pageContent",
  "pulsing-circle": "PageFrame-module__Yyy_ma__pulsing-circle",
  "pulsingCircle": "PageFrame-module__Yyy_ma__pulsingCircle",
  "questionMark": "PageFrame-module__Yyy_ma__questionMark",
});
